import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LogService, ServiceRouter, IAppDataStore } from '@pershing/pershing-core';
import { PortalComponentServiceDefinition } from './portal-component-service-definition';
import { Observable, BehaviorSubject } from 'rxjs';
import { Params } from '@angular/router';

@Injectable()
export class NxiRestService {
    private serviceUrl: string;
    accountList$: BehaviorSubject<any> = new BehaviorSubject([]);
    accountListObservable$ = this.accountList$.asObservable();
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter,
                private appDataStore: IAppDataStore, @Optional() @Inject('AppSettings') appSettings: any) {
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(PortalComponentServiceDefinition.getInstance());
        logService.info('NxiRestService : URL', this.serviceUrl);
    }

    public fetchUserAccounts(isManagedAccountsPage: boolean, isHouseHoldPage: boolean, isTrading: boolean, isTrading529: boolean): Observable<any> {
        console.log('isManagedAccountsPage ==>' + this.appDataStore.get('isManagedAccountsPage'));
        console.log('isHouseHoldPage ==>' + this.appDataStore.get('isHouseHoldPage'));
        // This flag would be set to true if change of account nickname/group/account link.
        let forceFetch: boolean = this.appDataStore.get('forcefetchOnAcctGrpChange');
        if (forceFetch) {
                this.appDataStore.put('forcefetchOnAcctGrpChange', false);
        }
        const timeNow = Date.now();
        this.http.get(this.serviceUrl + '/portfolio/accounts?time=' + timeNow, { responseType: 'json' }).subscribe((data: any) => {
                if (!!data && data.length > 1) {
                    this.appDataStore.put('isManagedAccountsPage', 'false');
                    this.appDataStore.put('isHouseHoldPage', 'false');

                    let group = data.filter(function (account) { return account.group || account.acctNo === 'ALL'; });
                    let ungrouped = data.filter(function (account) { return !account.group && account.acctNo !== 'ALL'; });

                    let ungroupedIconied = ungrouped.map(account => this.updateDisplay(account, isManagedAccountsPage, isHouseHoldPage));
                    let groupIconied = group.map(account => this.updateDisplay(account, isManagedAccountsPage, isHouseHoldPage));
                    let accountsList = groupIconied.concat(ungroupedIconied);
                    // added this check because code inside was refactored from updateDisplay function
                    if (accountsList.length > 1) {
                        // null and undefined check
                        if (!isHouseHoldPage) {
                            isHouseHoldPage = false;
                        }
                        if (isManagedAccountsPage) {
                            this.appDataStore.put('isManagedAccountsPage', isManagedAccountsPage);
                        } else {
                            this.appDataStore.put('isHouseHoldPage', isHouseHoldPage);
                        }
                    }

                    accountsList = this.updateAccountList(accountsList, isManagedAccountsPage, isHouseHoldPage, isTrading, isTrading529);
                    this.appDataStore.put('ACCOUNTS_LIST', accountsList);
                    this.accountList$.next(accountsList);
                } else {
                    this.accountList$.next([]);
                }
            },
                error => {
                    this.accountList$.next([]);
                });
        return this.accountListObservable$;
    }

    updateDisplay(account: any, isManagedAccountsPage: boolean, isHouseHoldPage: boolean) {
        if (isManagedAccountsPage) {
            account.showIcon = account.pesIdInd === 'L' || account.hhIcon;
        } else {
            account.showIcon = isHouseHoldPage && (account.pesIdInd === 'L' || account.hhIcon || account.acctTypeCode === 'L');
        }
        return account;
    }

    // updateAccountList(accountsList: any[], isManagedAccountsPage: boolean, isHouseHoldPage: boolean, isTrading: boolean, isTrading529: boolean) {
    //     let tempIndvAccountlist = [];
    //     let accountCriteria: ((account) => boolean)[] = [
    //         account => isManagedAccountsPage && (account.pesIdInd === 'L' || account.hhIcon),
    //         account => !isManagedAccountsPage && (isHouseHoldPage || !account.group || !(account.acctTypeCode === 'L' || account.hhIcon)),
    //         account => isTrading && account.tradingEnabled,
    //         account => isTrading529 && account.trading529Enabled
    //     ];
    //     // filter out 'ALL' account entry before cycling through criteria (only if there is 1 other entry besides ALL)
    //     accountsList = accountsList.filter(account => account.acctNo !== 'ALL' || accountsList.length !== 2);
    //     for (let criteria of accountCriteria) {
    //         // filtering from original list for each criteria and removing duplicates, then adding them to temp list
    //         tempIndvAccountlist = tempIndvAccountlist.concat(accountsList.filter(criteria).filter(account => tempIndvAccountlist.indexOf(account) < 0));
    //     }
    //     accountsList = tempIndvAccountlist;
    //     return accountsList;
    // }
    updateAccountList(accountsList: any[], isManagedAccountsPage: boolean, isHouseHoldPage: boolean, isTrading: boolean, isTrading529: boolean) {
        let tempIndvAccountlist = [];
        // let tempReorderedAccountlist = [];

        for (let account of accountsList) {
            if (account.acctNo === 'ALL' && accountsList.length === 2) {
                continue;
            }
            if (isManagedAccountsPage) {
                if (account.pesIdInd === 'L' || account.hhIcon) {
                    tempIndvAccountlist.push(account);
                }
            } else {
                if (isTrading529 || isTrading) {
                    if (isTrading && account.tradingEnabled) {
                        tempIndvAccountlist.push(account);
                    }
                    if (isTrading529 && account.trading529Enabled) {
                        tempIndvAccountlist.push(account);
                    }
                } else {
                    tempIndvAccountlist.push(account);
                    if (!isHouseHoldPage && account.group && (account.acctTypeCode === 'L' || account.hhIcon)) {
                        tempIndvAccountlist.pop();
                    }
                }
            }
        }
        // if (this.ssoDefaultAccount) {
        //     let ssoAccount = null;
        //     for (let indvAccount of tempIndvAccountlist) {
        //         if (indvAccount.acctNo === this.ssoDefaultAccount) {
        //          ssoAccount = indvAccount;
        //          break;
        //         }
        //     }
        //     // set the sso default account at the first place
        //     tempReorderedAccountlist.push(ssoAccount);
        //     for (let indvAccount of tempIndvAccountlist) {
        //         if (indvAccount.acctNo !== this.ssoDefaultAccount) {
        //          tempReorderedAccountlist.push(indvAccount);
        //         }
        //     }
        //     }
        accountsList = tempIndvAccountlist;
        return accountsList;
    }

    public getNxiPreLoginRestResponse(url: string, queryParams: Params): Observable<any> {
        let body = this.convertQueryParamToHttpParams(queryParams);
        return this.http.post(this.serviceUrl + '/prelogin/' + url, body);
    }

    private convertQueryParamToHttpParams(queryParams: Params): HttpParams {
        let param = new HttpParams();
        if (queryParams === null) {
            return param;
        }
        for (let query in queryParams) {
            if (queryParams.hasOwnProperty(query)) {
                param = param.set(query, queryParams[query]);
            }
        }
        return param;
    }
}
